/**
 * Sonde de capacité WebGL, tenue à part du fond animé : elle doit pouvoir être
 * consultée sans faire venir les huit cent kilo-octets du module qui l'utilise.
 *
 * L'appel ouvre un vrai contexte : il ne se fait donc jamais pendant le rendu
 * ni sur le chemin critique du démarrage, mais au premier moment creux.
 */
let probed: boolean | null = null;

const probe = (): boolean => {
  try {
    const canvas = document.createElement("canvas");
    // three 0.179 ne sait ouvrir qu'un contexte WebGL2 : sonder « webgl »
    // donnerait un faux positif suivi d'une exception au montage du canvas.
    const gl = canvas.getContext("webgl2");
    // Le contexte de sondage est rendu tout de suite : les navigateurs n'en
    // gardent qu'une poignée, et celui du fond va s'ouvrir juste après.
    gl?.getExtension("WEBGL_lose_context")?.loseContext();
    return Boolean(gl);
  } catch {
    return false;
  }
};

/** Le verdict est retenu : une seule ouverture de contexte pour toute la page. */
export const supportsWebGL = (): boolean => (probed ??= probe());
